// Remembers the page a signed-out user tried to open, so that after logging in
// they land back on it instead of always starting from the dashboard.
const STORAGE_KEY = "btComms.returnPath";
const NOT_RETURNABLE = ["/login", "/login/callback", "/not-authorized"];

const isSafePath = (path: string | null): path is string =>
  !!path && path.startsWith("/") && !path.startsWith("//");

export const saveReturnPath = (path: string): void => {
  const pathname = path.split(/[?#]/)[0];
  if (!isSafePath(path) || NOT_RETURNABLE.includes(pathname)) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    // Storage can be unavailable (private mode); login then falls back to the dashboard.
  }
};

export const takeReturnPath = (fallback = "/dashboard"): string => {
  try {
    const path = window.sessionStorage.getItem(STORAGE_KEY);
    window.sessionStorage.removeItem(STORAGE_KEY);
    if (isSafePath(path)) return path;
  } catch {
    // Ignore storage errors and use the fallback.
  }
  return fallback;
};
